module.exports = __webpack_public_path__ + "static/image3-f9bf74c0fbad21147bdb3105fc5b76b6.jpg";